import { motion } from 'framer-motion'
import { SparklesIcon } from '../UI/Icons'

const DEFAULT_DESCRIPTION =
  'Pick your favourites to request a quote. All proposals are subject to venue availability at ' +
  'the time - our experts will add a few more venue options they think work best to the mix! ' +
  'Alternatively, skip this step and we choose for you!'

interface Props {
  onHowItWorksClick: () => void
  description?: string
}

const ConciergeAIInfoBox = ({ onHowItWorksClick, description = DEFAULT_DESCRIPTION }: Props) => (
  <motion.div
    initial={{ opacity: 0, y: -10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4, delay: 0.35, ease: 'easeOut' }}
    className='bg-[rgba(175,35,28,0.05)] rounded-lg p-2 flex flex-col gap-4'>
    <div className='flex items-center justify-between'>
      <div className='flex items-center gap-1 text-[#af231c]'>
        <SparklesIcon />
        <span className='font-bold text-sm'>ConciergeAI</span>
      </div>
      <button
        type='button'
        onClick={onHowItWorksClick}
        className='text-[#af231c] text-sm font-medium cursor-pointer hover:underline'>
        How does this work?
      </button>
    </div>
    <p className='text-base text-black leading-6'>{description}</p>
  </motion.div>
)

export default ConciergeAIInfoBox
